import { FC, ReactElement, ReactNode } from 'react';
import { Call, StreamCall, StreamVideo, StreamVideoClient } from '@stream-io/video-react-sdk';

type CallSessionProps = {
  client: StreamVideoClient;
  call: Call;
  children: ReactNode;
};

const CallSession: FC<CallSessionProps> = ({ client, call, children }: CallSessionProps): ReactElement => {
  return (
    <StreamVideo client={client}>
      <StreamCall call={call}>
        {children}
      </StreamCall>
    </StreamVideo>
  );
};

export default CallSession;